











































import Vue from 'vue';
import LanguageCapabilityUtils, {
  LanguageCapability,
} from '@/utils/LanguageCapabilityUtils';
import { locales } from '@/i18n';

export default Vue.extend({
  computed: {
    table() {
      return {
        items: this.items,
        headers: [
          {
            text: this.$i18n.tc('languageCapability.key'),
            value: 'key',
          },
          {
            text: this.$i18n.tc('languageCapability.domain.label'),
            value: 'domain',
          },
          {
            text: this.$i18n.tc('languageCapability.text'),
            value: 'text',
          },
          {
            text: this.$i18n.tc('languageCapability.language'),
            value: 'language',
          },
          {
            text: this.$i18n.tc('languageCapability.visible.label'),
            value: 'visible',
          },
          {
            text: '',
            value: 'actions',
          },
        ],
      };
    },

    locales() {
      return locales;
    },
  },

  data: (): {
    items?: LanguageCapability[];
  } => ({
    items: undefined,
  }),

  async mounted() {
    try {
      this.items = await LanguageCapabilityUtils.languageCapability.api.list();
    } catch (error) {
      console.error(error);
    } finally {
      //
    }
  },

  methods: {
    async handleEdit(item: LanguageCapability) {
      await this.$router.push({
        name: 'languageCapability-edit',
        params: { id: item.id.toString() },
      });
    },

    async handleCreate() {
      await this.$router.push({
        name: 'languageCapability-create',
      });
    },
  },
});
